<template>
    <div class="container wrapper">
        <div class="row">
            <Header></Header>
        </div>
        <div class="row">
            <div class="col-md-8">
                <div class="stage">
                    <slot name="stage"></slot>
                </div>
            </div>
            <div class="col">
                <div class="main">
                    <slot name="main"></slot>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col"></div>
        </div>
        <div class="push"></div>
    </div>
</template>

<script>
    import Header from '@/components/Header'

    export default {
        name: 'Page',
        components: {
            Header
        }
    }
</script>

<style>
/*.videobg-content {*/
/*    overflow-y: auto;*/
/*}*/
/*html, body {*/
/*    height: 100%;*/
/*    margin: 0;*/
/*}*/
.wrapper {
    min-height: 100%;
    /* Equal to height of footer */
    /* But also accounting for potential margin-bottom of last child */
    margin-bottom: -130px;
}
/*.footer,*/
/*.push {*/
/*    height: 130px;*/
/*}*/
</style>
